import axios from 'axios';
import { api, headers } from '../../app/conf';
import { makeQuery } from '../../shared/helpers/commons';

export const getStatuses = (filters, type, token) =>
    axios({
        method: 'get',
        url: `${api}/tickets/${type}/statuses?${makeQuery(filters)}`,
        headers: {
            ...headers,
            'X-Access-Token': token,
            persistResponse: true
        }
    });

export const getTransitions = (status_id, filters, type, token) =>
    axios({
        method: 'get',
        url: `${api}/tickets/${type}/workflowtransitions/${status_id}?${makeQuery(filters)}`,
        headers: {
            ...headers,
            'X-Access-Token': token
        }
    });
